import React from 'react';
import { Typography, TypographyProps } from 'components/v2';
import { CheckCircle, Close, Warning, SvgIconComponent } from '@material-ui/icons';
import { WithStyles, withStyles } from '@material-ui/core';

import { styles } from './index.styles';

export enum AppointmentStatus {
  Unconfirmed = 'unconfirmed',
  Confirmed = 'confirmed',
  Cancelled = 'cancelled',
}

type PropertyMap = {
  [key in AppointmentStatus]: {
    color: TypographyProps['color'];
    label: string;
    icon: SvgIconComponent;
  };
};

const propertiesMap: PropertyMap = {
  [AppointmentStatus.Unconfirmed]: { color: 'secondary', label: 'Unconfirmed', icon: Warning },
  [AppointmentStatus.Confirmed]: { color: 'accentAloe', label: 'Confirmed', icon: CheckCircle },
  [AppointmentStatus.Cancelled]: { color: 'accentWatermelon', label: 'Cancelled', icon: Close },
};

type StatusChipProps = {
  status?: AppointmentStatus;
};

type Props = StatusChipProps & WithStyles<typeof styles>;

const StatusChipComponent: React.FunctionComponent<Props> = ({ status, classes }) => {
  if (status == null) {
    return <Typography>-</Typography>;
  }

  const { color, label, icon: Icon } = propertiesMap[status];

  return (
    <Typography noWrap color={color} variant="bW400F12">
      <Icon className={classes.icon} color="inherit" fontSize="small" />
      {label}
    </Typography>
  );
};

export const StatusChip = withStyles(styles)(StatusChipComponent);
